import React from "react";
import { Col } from "reactstrap";

const DashboardTop = () => {
  return <Col md={12} className="dashboardTop"></Col>;
};

export default DashboardTop;
